<app-modal [header]="title | translate">
  <div modal-body>
    <label class="form-label" for="textInput">{{ description | translate }}</label>
    <input appInputAutoFocus class="form-control w-100" id="textInput" name="textInput" type="text" [(ngModel)]="inputValue" (keydown)="submitEnter($event)">
  </div>
  <ng-container modal-footer>
    <button class="btn btn-secondary" (click)="bsModalRef.hide()"> {{ 'global.label.cancel' | translate }}</button>
    <button class="btn btn-primary" (click)="finish.emit(inputValue())"> {{ 'global.label.ok' | translate }}</button>
  </ng-container>
</app-modal>
